import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';
import './BlogDetail.css';
import { FaCalendarAlt, FaArrowLeft, FaTags } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const BlogDetail = () => {
  const { id } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        const data = await api.get(`/blogs/${id}`);
        setPost(data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPost();
  }, [id]);

  if (loading) return <div className="loading-spinner"></div>;
  if (error) return <div className="error-message">Error: {error}</div>;
  if (!post) return <div className="not-found-container">Blog post not found</div>;

  return (
    <div className="blog-detail">
      <div className="blog-header">
        <Link to="/bloglist" className="back-button">
          <FaArrowLeft /> Back to All Blogs
        </Link>
      </div>

      <div className="blog-header">

        
        <div className="header-content">
          <h1 className="blog-title">{post.title}</h1>
          <div className="blog-meta">
            <span className="publish-date">
              <FaCalendarAlt /> {new Date(post.created_at).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </span>
          </div>
        </div>
      </div>

      {post.image_url && (
        <div className="featured-image-container">
          <img 
            src={post.image_url} 
            alt={post.title} 
            className="featured-image" 
            loading="lazy"
          />
        </div>
      )}

      <div className="blog-content-container">
        <div 
          className="blog-content" 
          dangerouslySetInnerHTML={{ __html: post.content }} 
        />
        
        {post.tags && (
          <div className="blog-tags">
            <FaTags className="tags-icon" />
            {post.tags.split(',').map((tag, index) => (
              <span key={index} className="tag">{tag.trim()}</span>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogDetail;